import React, { useMemo } from 'react';
import styled from 'styled-components';
import { Button as BaseButton, FlexCenter } from '@ubeya/shared-web/components';

const Button = styled(BaseButton)`
  width: 160px;
  padding: 13px 0;
`;

const Link = styled.a`
  color: inherit;
  text-decoration: none;
  gap: 4px;
`;

const ContentWrappwer = styled(FlexCenter)``;

const Content = ({ text, Icon }) => (
  <ContentWrappwer>
    {Icon && <Icon />}
    {text}
  </ContentWrappwer>
);

export const EmptyStateButton = ({ link, Icon, type, text, onClick }) => {
  const content = useMemo(() => <Content Icon={Icon} text={text} />, [Icon, text]);
  return (
    <Button {...(type && { [type]: true })} onClick={onClick}>
      {link ? (
        <Link href={link} target="_blank" rel="noreferrer">
          {content}
        </Link>
      ) : (
        content
      )}
    </Button>
  );
};
